import React, { useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Transforms, Editor as SlateEditor } from 'slate';
import { useSlate } from 'slate-react';
import { FileZone } from 'app/components';
import { DataImage } from 'app/components';
import { i18n } from 'app/utils/i18n';
import { useEditorSelector } from 'app/state/contexts/EditorContext';
import { queryKeys, useImagesInDocument } from 'app/api/documents/image-queries';
import { useState } from 'react';
import { request } from 'app/api/request';
import { useQueryClient } from 'react-query';
export const ImportImage = ({ onClose }) => {
  const editor = useSlate();
  const pDocument = useEditorSelector((editor) => editor.pDocument);
  const { data: images, isLoading, refetch } = useImagesInDocument(pDocument.superId);
  const queryClient = useQueryClient();
  const [selectedImage, setSelectedImage] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const handleSelect = () => {
    if (!selectedImage) {
      return;
    }
    const slateImage = {
      type: 'image',
      uuid: uuidv4(),
      imageSuperId: selectedImage.file.superId,
      children: [],
    };
    const point = SlateEditor.end(editor, editor.selection);

    if (point) {
      Transforms.insertNodes(editor, slateImage, {
        at: point,
      });
    }
    setSelectedImage(null);
    onClose();
  };

  const handleUploadSuccess = async ({ data }) => {
    await request.post(`/gaby/documents/${pDocument.superId}/actions`, {
      action: 'create_image',
      data: {
        revisionId: data.revisionId,
        superId: data.superId,
      },
    });
    if (isMounted.current) {
      queryClient.invalidateQueries([queryKeys.images]);
      refetch();
      setUploadingFile(null);
    }
  };
  return (
    <div>
      <FileZone
        type="img"
        old={null}
        documentId={pDocument.superId}
        onProgress={(progress) => setProgress(progress)}
        onFileSelect={(file) => setUploadingFile(file)}
        onSuccess={handleUploadSuccess}
      />
      <div className="progress-bar-wrapper">
        {uploadingFile && (
          <>
            <div className="progress-bar-label">
              <span>{uploadingFile?.name}</span>
              <span>{progress}%</span>
            </div>

            <div class="progress" style={{ width: '100%' }}>
              <div class="progress-bar" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </>
        )}
      </div>
      {isLoading ? (
        <h2 style={{ marginTop: '20px', textAlign: 'center' }}>{i18n('imageimport.loading')}</h2>
      ) : (
        <>
          <div className="image-grid">
            {images?.map((image) => (
              <div
                className={`import-image-cell ${selectedImage?.file?.revisionId === image.file.revisionId && 'selected-image'}`}
                key={image.file.superId}
                onClick={() => setSelectedImage(image)}
              >
                <DataImage
                  {...image.file}
                  style={{ flex: 1, objectFit: 'contain', borderTopLeftRadius: '8px', borderTopRightRadius: '8px', backgroundColor: 'white' }}
                />
                <span className="image-name">{image.file?.filename}</span>
              </div>
            ))}
          </div>
          <div className="image-footer">
            <button
              className="btn btn-secondary"
              onClick={(e) => {
                e.persist();
                onClose();
              }}
            >
              {i18n('imageimport.close')}
            </button>
            <button className="btn btn-primary" disabled={!selectedImage} onClick={() => handleSelect()}>
              {i18n('imageimport.select')}
            </button>
          </div>
        </>
      )}
    </div>
  );
};
